<span [class.displayBlock]="displayBlock"
      class="control-container">
  <span class="loading-spinner"
        [style.height]="sizePx + 'px'"
        [style.width]="sizePx + 'px'"></span>
</span>
